//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Button from 'components/mixins/Button.vue'

export default {
  block: 'button',
  props: ['text','icon','blockModifiers','path'],
  mixins: [Button],
  computed: {
    route() {
      return '/' + this.path;
    }
  },
  methods: {
    getBlockModifiers() {
      let bms = this.block;
      if (this.blockModifiers) {
        this.blockModifiers.forEach( (blockModifier, index) => {
          bms += ' bm-'+blockModifier;
        });
      }
      return bms;
    }
  },
}



// WEBPACK FOOTER //
// ./components/blocks/Button.vue